// extracted by mini-css-extract-plugin
module.exports = {"block":"_17615","hd":"_15492","title":"_19714","arrow":"_13942","empty":"_250","bd":"_1912","ft":"_12590"};